import { createSelector } from 'reselect';

export function getAssessmentsItems(state) {
  return state.assessment_items;
}

export function getAssessmentItemById(state, assessmentItemId) {
  return getAssessmentsItems(state).get(assessmentItemId);
}
